/**
 * @param {string} path
 * @returns {*}
 */
function isStaticFile (path) {
  if (!path) return false

  const extensions = /\.(?:css|ttf|woff|woff2|svg|png|jpg|jpeg|js|json)$/i
  return extensions.test(path)
}

module.exports = { isStaticFile }
